export default "__VITE_ASSET__252ed216__"